import store from "@/store";
import { AxiosUtil } from "./axios.util";
import LogoutUser from "./logout-user";
import { getToken } from "./authServiceCookie";

export default function AxiosUtilInterceptors() {
    AxiosUtil.interceptors.request.use((config) => {
        const globalActivePage = store.getters["panel/getGlobalActivePage"];
        const requestUrl = config.baseURL
            ? new URL(config.url ?? "", config.baseURL).href
            : config.url ?? "";

        // Don't attach page header for external APIs (sayyarpay.top) or localhost
        // These APIs don't support the 'page' header in CORS
        const isExternalApi = requestUrl ?
            (requestUrl.includes("sayyarpay.top") ||
                requestUrl.startsWith("http://localhost:300")) : false;
        const shouldAttachPageHeader = !isExternalApi;

        if (getToken()) {
            config.headers.Authorization = `Bearer ${getToken()}`;
            config.headers["Content-Type"] = "application/json";
            if (shouldAttachPageHeader) {
                config.headers.page = globalActivePage;
            }
            store.dispatch("panel/updateLoadingPanel", true);
        } else {
            store.dispatch("auth/toggleLoading", true);
        }

        //  else {
        //   LogoutUser();
        // }

        return config;
    }),

        AxiosUtil.interceptors.response.use((response) => {
            try {
                if (response.data?.data?.pages) {
                    const pagination = {
                        limit: response.data.data.limit || 50,
                        page: response.data.data.page,
                        pages: response.data.data.pages,
                        total: response.data.data.total,
                    }
                    store.dispatch("panel/setGlobalPagination", pagination);
                }

                const method = response.config.method;
                const ignoreRoutes = ["pool/filter", "total", "not-verified", "all", "dashboard/stats", "manual-charges/stats"];
                const isIgnoreRoute = ignoreRoutes.some(route => response.config.url?.includes(route));
                const toast = {
                    status: true,
                    type: "",
                    message: ""
                };

                const statusCode = response.data.status;

                if (getToken()) {
                    store.dispatch("panel/updateLoadingPanel", false);
                } else {
                    store.dispatch("auth/toggleLoading", false);
                }

                if (!isIgnoreRoute) {
                    if (statusCode === 200 || statusCode === 201) {
                        toast.type = "success";
                        const message = response.data.message;
                        toast.message = typeof message === "string" && message.trim()
                            ? (message.trim().toLowerCase() === "success"
                                ? "عملیات با موفقیت انجام شد."
                                : message.trim())
                            : "عملیات با موفقیت انجام شد.";

                        if (method !== 'get' && !isIgnoreRoute) {
                            store.dispatch("app/updateToastModal", toast);
                        }

                    } else {
                        toast.type = "danger";
                        const message = response.data.message;
                        toast.message = typeof message === "string" && message.trim()
                            ? message.trim()
                            : "عملیات با مشکل روبه‌رو شد.";
                        store.dispatch("app/updateToastModal", toast);
                    }
                }

                return response;
            } catch (error) {
                console.error("Response interceptor error:", error);
                return Promise.reject(error);
            }
        },

            (error) => {
                const isAuthRequest = /(^|\/)auth\/(login|verify-otp)(?:\?|$)/.test(
                    error.config?.url ?? ""
                );
                if (!isAuthRequest) {
                    const toast = {
                        status: true,
                        type: "danger",
                        message: error.response?.data?.message || error.message || "خطایی رخ داده است، لطفا مجددا تلاش کنید"
                    };
                    store.dispatch("app/updateToastModal", toast);
                }
                if (getToken()) {
                    store.dispatch("panel/updateLoadingPanel", false);
                } else {
                    store.dispatch("auth/toggleLoading", false);
                }
                return Promise.reject(error);
            }
        );
}
